export enum MentionType {
    user = 1,
    group = 2,
}
